module.exports = __webpack_public_path__ + "93c28297fcb01f5a2797347c8f6bee6d.svg";